export default function isFootball(state) {
  return state.sport.sportName.toLowerCase() === 'football';
}
